export type FillTone = "primary" | "accent" | "success" | "warning";

const FILL_CLASS: Record<FillTone, string> = {
  primary: "bg-gradient-to-br from-primary-fill to-primary-fill-strong text-white",
  accent: "bg-gradient-to-br from-accent-fill to-accent-fill-strong text-white",
  success: "bg-gradient-to-br from-success-fill to-success-fill-strong text-white",
  warning: "bg-gradient-to-br from-warning-fill to-warning-fill-strong text-white",
};

/**
 * Brand gradient with white foreground for icon tiles, initials avatars, chips and
 * hero cards. Built on the theme-fixed `*-fill` tokens, so text and icons keep
 * >= 4.5:1 contrast in light and dark mode. Size, radius and shadow stay with the caller.
 */
export function brandFillClass(tone: FillTone): string {
  return FILL_CLASS[tone];
}
